<div>
  {{ field.checked | uppercase }}
</div>
<div *ngIf="field.hasTextInput">
  {{ field.textInputValue }}
</div>
